import { Box, IconButton, Typography } from '@mui/material';
import Image from 'next/image';

interface ImageUploadBoxProps {
  imageUrl?: string;
  placeholderText?: string;
  handleUpload: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleDelete: () => void;
  sx?: any
}

const ImageUploadBox: React.FC<ImageUploadBoxProps> = ({
  imageUrl,
  sx,
  placeholderText = 'Upload a cover photo',
  handleUpload,
  handleDelete,
}) => {
  return (
    <Box
      width='350px'
      height={380}
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      border='1.9px dashed rgba(217, 217, 217, 1)'
      borderRadius='8px'
      position='relative'
      sx={{...sx, cursor: 'pointer', mb: 2, overflow: 'hidden' }}>
      {/* Delete Button - Only Shows When Image Exists */}
      {imageUrl && (
        <IconButton
          onClick={handleDelete}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 4,
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            color: 'white',
            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.8)' },
          }}>
          <Image src='/icons/delete.svg' alt='Delete' width={20} height={20} />
        </IconButton>
      )}

      {/* Image Preview or Upload Prompt */}
      {imageUrl ? (
        <Image src={imageUrl} alt='Cover' layout='fill' objectFit='cover' style={{ zIndex: 2 }} />
      ) : (
        <>
          <Image src='/icons/upload.svg' alt='Upload' width={40} height={40} style={{ zIndex: 2 }} />
          <Typography color='#212d6d' align='center' variant='body2' mt={1} sx={{ zIndex: 2 }}>
            {placeholderText}
          </Typography>
          <Typography color='#5C6372' fontSize={'0.8rem'} sx={{ zIndex: 2 }}>
            (Optional)
          </Typography>
        </>
      )}

      {/* Hidden File Input */}
      <input
        type='file'
        accept='image/*'
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          opacity: 0,
          cursor: 'pointer',
          zIndex: 3,
        }}
        onChange={handleUpload}
      />
    </Box>
  );
};

export default ImageUploadBox;
